import { AgendamentoConsultaInput, EscutaInicialInput, ProcedimentoAtendimentoInput } from 'graphql/types.generated'

import { AgendarConsultaPanelModel } from '../detail/soap/desfecho/components/AgendarConsultaPanel'
import { ManterCidadaoLista } from '../detail/soap/desfecho/components/DesfechoAtendimentoPanel'
import { convertMedicoesPanelToInput } from '../detail/soap/objetivo'
import { EscutaInicialState } from './model'

export const convertEscutaInicialModelToInput = (
  atendimentoId: ID,
  cidadaoId: ID,
  values: EscutaInicialState,
  isPreAtendimento: boolean
): EscutaInicialInput => ({
  id: atendimentoId,
  cidadaoId: cidadaoId,
  ciapId: values.motivoConsulta.ciap.id,
  motivoConsulta: values.motivoConsulta.texto,
  medicoes: convertMedicoesPanelToInput(values.medicoes),
  desfecho: {
    manterCidadaoLista: isPreAtendimento || values.desfecho.manterCidadaoLista === ManterCidadaoLista.SIM,
    atendimento: {
      cidadao: cidadaoId,
      equipe: values.desfecho.atendimento?.equipe?.id,
      lotacao: values.desfecho.atendimento?.lotacao?.id,
      tiposServico: values.desfecho.atendimento?.tiposServico,
    },
  },
  finalizadoEm: new Date().getTime(),
  classificacaoRiscoEnum: !isPreAtendimento ? values.classificacaoRisco : undefined,
  procedimentos: values.procedimentos?.map(
    (procedimento) =>
      ({
        id: procedimento.procedimento.id,
        cid10PrincipalId: procedimento.procedimento.procedimentoReferencia?.id,
        automatico: procedimento.automatico,
      } as ProcedimentoAtendimentoInput)
  ),
  agendamento: !isPreAtendimento ? convertAgendarConsulta(values.agendarConsulta, cidadaoId) : undefined,
})

export const convertAgendarConsulta = (
  agendarConsulta: AgendarConsultaPanelModel,
  cidadaoId: ID
): AgendamentoConsultaInput =>
  agendarConsulta?.lotacao && {
    lotacao: agendarConsulta?.lotacao?.id,
    cidadao: cidadaoId,
    horario: Number(agendarConsulta?.horario?.inicial),
    isForaUbs: false,
  }
